if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  function attachVariantChangeListener() {
    const variantInputs = document.querySelectorAll(
      "[bss-b2b-product-form] input.product-option"
    );
    if (variantInputs.length) {
      variantInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          const productForm = document.querySelector(
            "[bss-b2b-main-product-form]"
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        });
      });
    }
  }

  function runWithRetry(callback, interval = 1000, maxAttempts = 30) {
    let attempts = 0;
    const intervalId = setInterval(() => {
      callback();
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, interval);
  }

  document.addEventListener("DOMContentLoaded", () => {
    const path = window.location.pathname;

    if (path.includes("/products")) {
      runWithRetry(attachVariantChangeListener, 1000, 30);
    }

    if (path.includes("/cart")) {
      setTimeout(() => {
        BSS_B2B.observer.cartSubject.listenCartCheckout();
      }, 2000);

      runWithRetry(
        () => {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        },
        1000,
        30
      );
    }
  });
}
